export default __webpack_public_path__ + "static/footer-logo-5e88504cc5b5410a80f254663c457175.svg";